import { GoodTableOptions, GoodTablePaginationOptions, GoodTableSelectOptions, GoodTableSortOptions } from '@/components/GoodTable/GoodTable.types';
import { getDateFormatYMD } from '@/utils/date';
/**
 * 基础数据分析选项抽象类
 * 提取 CompanyDataAnalysisOptions 和 AccountDataAnalysisOptions 的公共部分
 */
export class BaseDataAnalysisOptions {
    constructor() {
        /**
         * 标题
         */
        this.title = '';
        /**
         * 副标题
         */
        this.subTitle = '';
        /**
         * 接口标识
         */
        this.reportName = '';
        /**
         * 标题tips
         */
        this.tips = [];
        /**
         * 解释型标题
         */
        this.explain = '';
        this.loading = false;
        /**
         * noData
         */
        this.noData = false;
        this.chartDescription = false;
        /**
         * 图表描述列表 - 可选属性，子类可以选择性实现
         */
        this.chartDescriptionList = [];
        /**
         * 数据更新时间
         */
        this._updated = null;
        /**
         * 是否包含折叠功能
         */
        this.canCollapse = true;
        /**
         * 是否可修改视图类型
         */
        this.canChangeViewType = true;
        /**
         * 表格Column
         */
        this.tableColumn = [];
        this.tableOptions = (() => {
            const tableOptions = new GoodTableOptions();
            tableOptions.columns = [];
            tableOptions.fixedHeader = true;
            const paginationOptions = new GoodTablePaginationOptions();
            paginationOptions.enabled = false;
            tableOptions.paginationOptions = paginationOptions;
            const selectOptions = new GoodTableSelectOptions();
            selectOptions.enabled = false;
            tableOptions.selectOptions = selectOptions;
            const sortOptions = new GoodTableSortOptions();
            sortOptions.enabled = false;
            tableOptions.sortOptions = sortOptions;
            return tableOptions;
        })();
        this.chartOption = {};
        this.chartHeight = '336px';
        this.chartId = '';
    }
    set Updated(val) {
        this._updated = getDateFormatYMD(val, 'cn');
    }
    get Updated() {
        return this._updated;
    }
}
